import React, { useEffect, useRef, useState } from 'react';

function Quem() {
    const imageRef = useRef(null);
    const [isImageVisible, setIsImageVisible] = useState(false);

    useEffect(() => {
        const imageElement = imageRef.current;

        if (!imageElement) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsImageVisible(entry.isIntersecting);
            },
            {
                rootMargin: '0px 0px -12% 0px',
                threshold: 0.50,
            },
        );

        observer.observe(imageElement);

        return () => observer.disconnect();
    }, []);

    return (
        <div className="position-relative overflow-hidden p-1 p-md-5 m-md-3 text-center bg-light row align-items-center">
            <div className="col-md-5 p-lg-5  mx-auto my-3">
                <img
                    ref={imageRef}
                    src="desenho-2.png"
                    className={`img-fluid rounded-circle quem-image quem-image-flip ${isImageVisible ? 'is-visible' : ''}`}
                    alt="Ilustração de Manô Medeiros"
                />
            </div>
            <div className="col-md-5 p-lg-5 mx-auto my-3 content-section">
                <h2 className="m-3">Quem sou eu</h2>
                <p className="m-5 justificar-texto">Inquieta e afetuosa, sapatona que tem construído muito de sua identidade profissional também nos espaços de ativismo LGBTI+. Atuou como uma das diretoras da <a className="text-dark" target='_blank' rel="noopener noreferrer" href="https://www.somos.org.br">ONG Somos - Comunicação, Saúde e Sexualidade</a>, tendo entre 2020 e 2025 dedicado-se em projetos variados, supervisão de estágio de psicologia e facilitação de grupos de convivência.</p>
                <p className="m-5 justificar-texto">Possui experiência de trabalho em serviços do SUS no atendimento especializado às pessoas vivendo com HIV/AIDS. Apaixonada por poesia e pelo movimento do corpo, experimentando-se nas práticas de pole dance e corrida. Moradora da cidade de Porto Alegre - RS, mas com criação na região metropolitana, o que lhe traz um olhar atento as questões de território e socioeconômicas.</p>

            </div>
            
        </div>

    );
}

export default Quem;